let activateResizeHandler;

/**
 * Class representing a mobile navigation menu.
 */
class MobileNav {
	/**
	 * Create a mobile navigation menu.
	 * @param {Object} options - The options for the mobile navigation.
	 * @param {HTMLElement} options.container - The container element for the navigation.
	 * @param {boolean} [options.hideOnClickOutside=false] - Whether to hide the menu when clicking outside.
	 * @param {string} [options.menuActiveClass='nav-active'] - The class to add when the menu is active.
	 * @param {string} [options.menuOpener='.nav-opener'] - The selector for the menu opener element.
	 * @param {string} [options.menuDrop='.nav-drop'] - The selector for the menu drop element.
	 * @param {string} [options.toggleEvent='click'] - The event to toggle the menu.
	 * @param {string} [options.outsideClickEvent='click touchstart pointerdown MSPointerDown'] - The events to hide the menu when clicking outside.
	 */
	constructor(options) {
		this.options = {
			container: null,
			hideOnClickOutside: false,
			menuActiveClass: 'nav-active',
			menuOpener: '.nav-opener',
			menuDrop: '.nav-drop',
			toggleEvent: 'click',
			outsideClickEvent: 'click touchstart pointerdown MSPointerDown',
			...options,
		};
		this.initStructure();
		this.attachEvents();
	}

	/**
	 * Initialize the structure of the mobile navigation.
	 */
	initStructure() {
		this.page = jQuery('html');
		this.container = jQuery(this.options.container);
		this.opener = this.container.find(this.options.menuOpener);
		this.drop = this.container.find(this.options.menuDrop);
	}

	/**
	 * Attach event handlers for the mobile navigation.
	 */
	attachEvents() {
		const self = this;

		if (activateResizeHandler) {
			activateResizeHandler();
			activateResizeHandler = null;
		}

		this.outsideClickHandler = function (e) {
			if (self.isOpened()) {
				const target = jQuery(e.target);
				if (
					!target.closest(self.opener).length &&
					!target.closest(self.drop).length
				) {
					self.hide();
				}
			}
		};

		this.openerClickHandler = function (e) {
			e.preventDefault();
			self.toggle();
		};

		this.opener.on(this.options.toggleEvent, this.openerClickHandler);
	}

	/**
	 * Check if the menu is opened.
	 * @returns {boolean} - True if the menu is opened, false otherwise.
	 */
	isOpened() {
		return this.container.hasClass(this.options.menuActiveClass);
	}

	/**
	 * Show the mobile navigation menu.
	 */
	show() {
		this.container.addClass(this.options.menuActiveClass);
		if (this.options.hideOnClickOutside) {
			this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
		}
	}

	/**
	 * Hide the mobile navigation menu.
	 */
	hide() {
		this.container.removeClass(this.options.menuActiveClass);
		if (this.options.hideOnClickOutside) {
			this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
		}
	}

	/**
	 * Toggle the mobile navigation menu.
	 */
	toggle() {
		if (this.isOpened()) {
			this.hide();
		} else {
			this.show();
		}
	}

	/**
	 * Destroy the mobile navigation instance.
	 */
	destroy() {
		this.container.removeClass(this.options.menuActiveClass);
		this.opener.off(this.options.toggleEvent, this.clickHandler);
		this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
	}
}

activateResizeHandler = function () {
	let win = jQuery(window);
	let doc = jQuery('html');
	let resizeClass = 'resize-active';
	let flag;
	let timer;
	const removeClassHandler = function () {
		flag = false;
		doc.removeClass(resizeClass);
	};
	const resizeHandler = function () {
		if (!flag) {
			flag = true;
			doc.addClass(resizeClass);
		}
		clearTimeout(timer);
		timer = setTimeout(removeClassHandler, 500);
	};
	win.on('resize orientationchange', resizeHandler);
};

/*
 * Simple Mobile Navigation
 */
(($) => {
	$.fn.mobileNav = function (opt) {
		const [method, ...args] = arguments;

		return this.each(function () {
			const $container = $(this);
			let instance = $container.data('MobileNav');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				instance = new MobileNav({ container: this, ...opt });
				$container.data('MobileNav', instance);
			} else if (
				typeof method === 'string' &&
				instance &&
				typeof instance[method] === 'function'
			) {
				instance[method](...args);
			}
		});
	};
})(jQuery);
